export default "__VITE_ASSET__DMvIU8PZ__"